import { Component, Input, OnInit } from '@angular/core';
import { Banner, ListBanners } from '../../interface/banner.interface';
import { GoogleAnalyticsService } from '@hakimio/ngx-google-analytics';
import { Router } from '@angular/router';
import { environment } from '@/environments/environment';

@Component({
  selector: 'app-banner-policy',
  templateUrl: './banner-policy.component.html',
  styleUrls: ['./banner-policy.component.scss'] ,
})
export class BannerPolicyComponent {
  constructor(
    private router: Router,
    private gaService: GoogleAnalyticsService,
  ) {
  }
  @Input() banners: ListBanners | undefined;
  displayBanner: Banner[] = [];

    goToUrl(banner: Banner) {
    let params: any = {
      promotion_id: banner.campaignId,
      promotion_name: `${banner.campaignId}_quick_order_slide`,
      creative_name: banner.imgTextInside || '',
      creative_slot: 'quick_order_slider',
      items: [{
        item_id: banner.campaignId,
        item_name: banner.imgTextInside || 'Banner Slide',
        creative_name: banner.imgTextInside || '',
        item_brand: banner.campaignId,
      }],
    };

    if (banner.params) {
      params = {
        ...params,
        ...banner.params,
      };
    }

    if (banner.campaignId !== 'GTT' && environment.environment === 'production') {
      this.gaService.gtag('event', 'select_promotion', params);
    }

    if (banner && banner.direction) {
      this.router.navigateByUrl(banner.direction);
    }
  }

  ngOnChanges(): void {
    this.displayBanner =
      this.banners?.banners.filter((banner: Banner) => banner.display) || [];
  }
}
